// Initialize Firebase
export const clientConfig = {
    apiKey: process.env.PUBLIC_FB_API_KEY,
    authDomain: process.env.PUBLIC_FB_AUTH_DOMAIN,
    databaseURL: process.env.PUBLIC_FB_DB_URL,
    projectId: process.env.PUBLIC_FB_PROJECT_ID,
    storageBucket: process.env.PUBLIC_FB_STORAGE_BUCKET,
    messagingSenderId: process.env.PUBLIC_FB_MESSAGE_SID,
    appId: process.env.PUBLIC_FB_APP_ID,
    // The stream the gtag snippets use, so `ga-disable-<id>` covers Firebase too. An env without GA (e2e) sets ''.
    measurementId: process.env.PUBLIC_GA_TRACKING_ID || undefined,
};
